module.exports = __webpack_public_path__ + "img/wiiu.4c1946ed.svg";